import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconArrowRightBold = props => (
  <SvgIcon {...props} viewBox="0 0 12 10">
    <path d="m7.3668 6.1802-2.22 2.158 1.7095 1.6618 5.1437-5-5.1437-5-1.7095 1.6618l2.22 2.158h-7.3668v2.3603h7.3668z" />
  </SvgIcon>
);

export default IconArrowRightBold;



// WEBPACK FOOTER //
// ./src/components/icons/IconArrowRightBold.js